module.exports = __webpack_public_path__ + "img/head1.aa9a0956.png";